// Deliberately permissive: the backend (and ultimately the mail server) decides whether an address
// is real. This only catches the obvious typos — missing @, missing domain, stray spaces or commas
// from a pasted list — before spending a request on them.
const EMAIL_PATTERN = /^[^\s,;<>()"]+@[^\s,;<>()"]+\.[^\s,;<>()"]+$/;

export const isValidEmail = (value: string | undefined): boolean => EMAIL_PATTERN.test((value ?? '').trim());

export default isValidEmail;
